<template>
  <div class="d-flex align-start">
    <v-icon
      v-if="helpText.priceSensitive"
      class="mr-4"
      color="primary"
    >
      mdi-credit-card-outline
    </v-icon>
    <div>
      <template v-if="helpText.priceSensitive">
        <strong>Price sensitive question</strong>
        <br>
      </template>
      <p
        v-if="helpText.title || helpText.titleAdditional"
        v-html="isAdditional ? helpText.titleAdditional || helpText.title : helpText.title"
      />
      <component
        :is="helpText.collapsible ? 'show-more' : 'div'"
        :open-text="helpText.collapsible ? (helpText.openerText || 'Show More') : false"
        :hide-text="helpText.collapsible ? (helpText.closerText || helpText.openerText || 'Hide') : false"
      >
        <div v-html="isAdditional ? helpText.valueAdditional || helpText.value || helpText : helpText.value || helpText" />
      </component>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    helpText: {
      type: [Object, String],
      default: '',
    },
    isAdditional: Boolean,
  },
};
</script>
